<div class="pass-wrapper">
  <div class="password-reset-new">
    <app-secondary-logo />
    <form class="password-reset-new__form" [formGroup]="changePass" (ngSubmit)="setNewPassword()">
      <div class="password-reset-new__title">{{ 'resetPassNew.title' | translate }}</div>
      <div class="password-reset-new__subtitle">{{ 'resetPassNew.subtitle' | translate }}</div>

      <div class="password-reset-new__input-wrapper">
        <input
          [type]="isPasswordVisible()[0] ? inputType.TEXT : inputType.PASSWORD"
          class="password-reset-new__pass-input"
          formControlName="password"
          [class.input-error]="
            changePass.get('password')?.touched && changePass.get('password')?.invalid
          "
          [placeholder]="'resetPassNew.placeholderEnterPass' | translate"
        />
        <app-icon
          class="eye__icon"
          [icon]="isPasswordVisible()[0] ? iconName.PASSWORD_EYE : iconName.PASSWORD_EYE_HIDE"
          (click)="togglePasswordVisibility(0)"
        />
      </div>
      @if (changePass.get('password')?.touched && changePass.get('password')?.invalid) {
        @if (changePass.get('password')?.errors?.['required']) {
          <div class="password-reset-new__error-message">
            {{ 'resetPassNew.passRequired' | translate }}
          </div>
        } @else if (changePass.get('password')?.errors?.['minlength']) {
          <div class="password-reset-new__error-message">
            {{ 'resetPassNew.passMinLength' | translate }}
          </div>
        } @else if (changePass.get('password')?.errors?.['maxlength']) {
          <div class="password-reset-new__error-message">
            {{ 'resetPassNew.passMaxLength' | translate }}
          </div>
        } @else {
          <div class="password-reset-new__error-message">
            {{ 'resetPassNew.passInvalid' | translate }}
          </div>
        }
      }

      @if (errorMessage()) {
        <div class="password-reset-new__error-message">{{ errorMessage() }}</div>
      }

      <div class="password-reset-new__input-wrapper">
        <input
          [type]="isPasswordVisible()[1] ? inputType.TEXT : inputType.PASSWORD"
          class="password-reset-new__pass-input repeat"
          formControlName="repeatPassword"
          [class.input-error]="
            changePass.get('repeatPassword')?.touched && changePass.get('repeatPassword')?.invalid
          "
          [placeholder]="'resetPassNew.placeholderRepeatPass' | translate"
        />
        <app-icon
          class="eye__icon"
          [icon]="isPasswordVisible()[1] ? iconName.PASSWORD_EYE : iconName.PASSWORD_EYE_HIDE"
          (click)="togglePasswordVisibility(1)"
        />
      </div>
      @if (changePass.get('repeatPassword')?.touched && changePass.get('repeatPassword')?.invalid) {
        @if (changePass.get('repeatPassword')?.errors?.['required']) {
          <div class="password-reset-new__error-message">
            {{ 'resetPassNew.passRequired' | translate }}
          </div>
        } @else if (changePass.get('repeatPassword')?.errors?.['minlength']) {
          <div class="password-reset-new__error-message">
            {{ 'resetPassNew.passMinLength' | translate }}
          </div>
        } @else if (changePass.get('repeatPassword')?.errors?.['maxlength']) {
          <div class="password-reset-new__error-message">
            {{ 'resetPassNew.passMaxLength' | translate }}
          </div>
        } @else {
          <div class="password-reset-new__error-message">
            {{ 'resetPassNew.passInvalid' | translate }}
          </div>
        }
      }
      @if (
        changePass.get('password')?.valid &&
        changePass.get('repeatPassword')?.valid &&
        changePass.errors?.['passwordsDoNotMatch']
      ) {
        <div class="password-reset-new__error-message">
          {{ 'resetPassNew.passMatch' | translate }}
        </div>
      }
      <button type="submit" class="btn-primary password-reset-new__button">
        {{ 'resetPassNew.buttonReset' | translate }}
      </button>
    </form>
  </div>

  <div class="reset-password-banner">
    <div class="banner-content">
      <div class="reset-password-banner_picture">
        <img src="assets/images/key-dynamic.png" alt="Key" />
      </div>
    </div>
  </div>
</div>
